import React, { useEffect, useState, useRef } from "react";
import Typography from '@mui/material/Typography';

import ImageSelector from "./imageSelector/ImageSelector";
import ImageCropper from "./imageCropper/ImageCropper";
import './ImageUploader.css';

const ImageUploader = ({ close, croppedImage, fullImage, src, createSnackbar, imageMaxSize }) => {

  const [image, setImage] = useState("");
  const [imageLoader, setImageLoader] = useState(false);
  const input = useRef();

  useEffect(() => {
    if (src !== "" && image === "") {
      setImageLoader(true);
      setImage(src);
    }
  }, [src, image]);

  const handleSaveImage = (cropped_image) => {
    croppedImage(cropped_image);
    fullImage(image);
    close();
  }

  const handleDeleteImage = () => {
    input.current.value = null;
    setImage("");
    croppedImage("");
    fullImage("");
  }

  const handleInput = () => {
    input.current.click();
  }

  const handleReadImage = (imageFile) => {
    if (!imageFile) return;

    setImageLoader(true);

    if (!handleImageValidation(imageFile)) {
      setImageLoader(false);
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      if (e.target.result !== image) {
        setImage(e.target.result);
      } else {
        // TODO: add warning
        setImageLoader(false);
      }
    };

    reader.readAsDataURL(imageFile);
  }

  const handleChooseImage = (e) => {
    e.preventDefault();
    handleReadImage(e.target.files[0]);
  }

  const handleImageValidation = (imageFile) => {
    const type = imageFile.type;
    const size = imageFile.size;

    if (type !== "image/png" && type !== "image/jpg" && type !== "image/jpeg") {
      createSnackbar.error("Invalid file type!");
      return false;
    }

    if (size > (imageMaxSize)) {
      createSnackbar.error(`File must be less than ${imageMaxSize/1048576} MB!`);
      return false;
    }

    return true;
  }

  return (
    <div className="uploader">
      <input ref={input} type={'file'} onChange={handleChooseImage} style={{ display: "none" }} accept={"image/png, image/jpg, image/jpeg"} />
      <div className="uploader__top">
        <Typography variant="h2" component="h2" mb={2.5}>
          Upload profile picture
        </Typography>
        <Typography variant="body1" component="p" mb={0.5} fontWeight="fontWeightBold" >
          Mandatory guidelines for the ID card
        </Typography>
        <ul>
          <Typography variant="subtitle2" component="li" mb={0.25}>
            Please select a .jpg/jpeg or png image file with a plain background <b>only</b> and with closer face as per the sample.  The file should be smaller than {imageMaxSize/1048576} MB.
          </Typography>
          <Typography variant="subtitle2" component="li" mb={0.25}>
            Please place the photograph aligned to the marker as displayed in the preview.
          </Typography>
        </ul>
        <Typography variant="body1" component="p" mb={0.5} fontWeight="fontWeightBold" >
          Restricted images for the ID card
        </Typography>
        <ul>
          <Typography variant="subtitle2" component="li" mb={0.25}>
            Avoid selfie style or pictures of your face from the side.
          </Typography>
          <Typography variant="subtitle2" component="li" mb={0.25}>
            Avoid photos that have distracting elements in or as the background.
          </Typography>
          <Typography variant="subtitle2" component="li" mb={0.25}>
            Avoid using photos where you are wearing sunglasses.
          </Typography>
        </ul>
      </div>
      {
        image === ""
          ? <ImageSelector
            close={close}
            uploadedImage={handleReadImage}
            chooseImage={handleInput}
            imageLoader={imageLoader}
          />
          : <ImageCropper
            cancel={close}
            src={image}
            save={handleSaveImage}
            chooseImage={handleInput}
            deleteImage={handleDeleteImage}
            imageLoader={imageLoader}
            setImageLoader={setImageLoader}
            setImage={setImage}
            createSnackbar={createSnackbar}
          />
      }
    </div>
  );
}

export default ImageUploader;